import React, {useEffect} from 'react';
import {useRouter} from 'next/router';
import {getLocaleContent} from '@helper/locale-content.js';
import SlideBanner from '@components/common/SlideBanner/SlideBanner';
import SpecialistDoctorNav from '@components/SpecialistDoctor/SpecialistDoctorNav';
import SpecialistDoctorHome from '@components/SpecialistDoctor/SpecialistDoctorHome';
import {NextSeo} from 'next-seo';
import AppConfigService from '@services/app-config.service';
import UserService from '@services/user.service';
import {getAutoSEO} from '@helper/seo/seo';

export default function SpecialistDoctor(props) {
    const {locale} = useRouter();
    const router = useRouter();
    const {seoPage} = props;

    const {params} = router.query;
    const business_id = Array.isArray(params) ? params[0] : null;

    return (
        <>
            {seoPage && <NextSeo {...seoPage} />}
            <div>
                <SlideBanner titleBanner={getLocaleContent(locale, 'page.specialist-doctor.page-title')} />
                <SpecialistDoctorNav />
                <SpecialistDoctorHome businessId={business_id} />
            </div>
        </>
    );
}

SpecialistDoctor.getInitialProps = async context => {
    try {
        const ctx = context || {};
        const appConfigService = new AppConfigService(ctx);
        const seoConfig = await appConfigService.getAppConfig({page: 'SEO'});

        // Fetch data thực tế để tạo SEO tự động
        let pageData = {};
        try {
            const userService = new UserService(ctx);
            const doctorsResponse = await userService.getUserList({
                locale: ctx.locale || 'vn',
                pageSize: 1,
                pageIndex: 1,
            });
            const payload = doctorsResponse?.data?.data || doctorsResponse?.data || doctorsResponse;
            pageData.totalDoctors = payload?.totalItems || 0;
        } catch (err) {
            console.error('Failed to fetch doctors data for SEO:', err);
        }

        // Sử dụng getAutoSEO để tạo SEO tự động từ data
        let seoPage = getAutoSEO('BACSI', seoConfig, pageData);

        const webUrl = process.env.NEXT_PUBLIC_WEB_URL || 'https://tnh.com.vn';
        seoPage.canonical = `${webUrl}/chuyen-gia-bac-si`;
        if (seoPage.openGraph) {
            seoPage.openGraph.url = `${webUrl}/chuyen-gia-bac-si`;
        }

        return {seoPage};
    } catch (error) {
        console.error('Failed to fetch SEO for specialist doctor page:', error);
        return {seoPage: null};
    }
};
